var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRobotOutline = function SvgRobotOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM13 15a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zM17 15a1 1 0 1 1 0 2h-1a1 1 0 1 1 0-2zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9M15.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 15.5 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1a1 1 0 0 1 1 1v2h4c2.757 0 5 2.243 5 5v1h.5c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5H22v1c0 2.757-2.243 5-5 5H7c-2.757 0-5-2.243-5-5v-1h-.5C.673 16 0 15.327 0 14.5v-3c0-.827.673-1.5 1.5-1.5H2V9c0-2.757 2.243-5 5-5h4V2a1 1 0 0 1 1-1M7 6C5.346 6 4 7.346 4 9v8c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgRobotOutline;